import { FikoYTIstekKok } from "./fikoyt.istek.makinesi.service";

export type ISayfalama = { sayfa?: number, sayi?: number, siralama?: { [key: string]: any }, filitre?: any, ilkId?: any, sonId?: any, toplamKayitSayisi?: number, siralamalar?: { ismi: string; degeri: { [key: string]: number } }[] }


export interface IOptionsSayfalama {
    metod?: "POST" | "GET" | "PUT" | "DELETE" | "PATCH" | "OPTIONS" | "HEAD" | "TRACE" | "CONNECT",
    komut?: string,
    onEkOlsun?: boolean,
    parametreler?: any,
    filitreler?: any[],
    tekrarSayisi?: number,
    tekrarBekleme?: number,
    oncelik?: number,
    depoModu?: boolean,
    gecikmeliCevapSuresi?: number,
    gecikmeliCevap?: boolean,
    otoMesgul?: boolean,
    otoIlkId?: boolean,
    otoSonId?: boolean,
    eklemeliListe?: boolean,
    sayfalama?: ISayfalama,
    [key: string]: any
}

export class FikoYTIstekSayfalama<T = any> extends FikoYTIstekKok<T> {

    public sayfalama: ISayfalama = { sayfa: 1, sayi: 5, siralama: { _id: -1 }, filitre: null, ilkId: null, sonId: null, toplamKayitSayisi: 0 }

    public liste: any[] = [];

    override parametreler: any = null;

    public filitreler: any[] = [];

    public suzgecModu: number | any = 0

    constructor(public options: IOptionsSayfalama) {
        super(options);

        this.options.eklemeliListe = this.options.eklemeliListe ?? true;

        this.filitreler = this.options.filitreler ?? [];
        this.sayfalama = { ...this.sayfalama, ...(this.options.sayfalama ?? {}) };

        this.parametreler = {
            aggregate: this._alAggregate()
        }

        this.onOnceCevap(({ self, sonuc }) => {
            // console.log(sonuc);
            if (sonuc instanceof Array) {
                this.sayfalama = sonuc[0].sayfalama;
                // console.log(this.liste);
                return sonuc[0].liste ?? sonuc
            }
            return sonuc
        })

        this.onCevap(({ self, sonuc }) => {
            if (this.options.eklemeliListe) {
                if (sonuc instanceof Array) {
                    this.liste.push(...sonuc ?? sonuc)
                }
            } else {
                this.liste = sonuc ?? [];
            }
        })



    }

    _alAggregate() {
        return [
            //---->
            ...(this.filitreler ?? []).filter(Boolean).flatMap((f: any) => Array.isArray(f) ? f : [f]),
            // {
            //     $match: {
            //         isim: { $regex: "", $options: "i" }
            //     }
            // },
            // Eğer cursor bazlı filtre varsa (ilkid veya sonId)
            {
                $sort: {
                    ...this.sayfalama.siralama
                },
            },
            {
                $setWindowFields: {
                    sortBy: { createdAt: 1 }, // Sıralama ölçütü
                    output: {
                        siraNo: {
                            $documentNumber: {} // Sıra numarası ekler (1'den başlar)
                        }
                    }
                }
            },
            {
                $facet: {
                    toplam: [
                        {
                            $count: "toplam",
                        },
                    ],
                    liste: [
                        {
                            $sort: {
                                ...this.sayfalama.siralama
                            },
                        },
                        {
                            $skip: this.sayfalama.sayi * (this.sayfalama.sayfa - 1),
                        },
                        {
                            $limit: this.sayfalama.sayi,
                        },

                    ],
                },
            },
            {
                $set: {
                    ilkId: {
                        $cond: {
                            if: { $gt: [{ $size: "$liste" }, 0] },
                            then: {
                                $getField: {
                                    field: "_id",
                                    input: { $arrayElemAt: ["$liste", 0] }
                                }
                            },
                            else: { $literal: this.sayfalama.ilkId }
                        }
                    },
                    sonId: {
                        $cond: {
                            if: { $gt: [{ $size: "$liste" }, 0] },
                            then: {
                                $getField: {
                                    field: "_id",
                                    input: {
                                        $arrayElemAt: ["$liste", { $subtract: [{ $size: "$liste" }, 1] }]
                                    }
                                }
                            },
                            else: { $literal: this.sayfalama.sonId }
                        }
                    }
                }
            },
            {
                $replaceRoot: {
                    newRoot: {
                        sayfalama: {
                            sayi: this.sayfalama.sayi,
                            sayfa: this.sayfalama.sayfa,
                            filitre: this.sayfalama.filitre,
                            siralama: this.sayfalama.siralama,
                            ilkId: this.options.otoIlkId ? "$ilkId" : this.sayfalama.ilkId,
                            sonId: this.options.otoSonId ? "$sonId" : this.sayfalama.sonId,
                            toplamKayitSayisi: {
                                $ifNull: [
                                    {
                                        $arrayElemAt: ["$toplam.toplam", 0],
                                    },
                                    0,
                                ],
                            },
                        },
                        liste: "$liste",
                    },
                },
            }
        ]
    }

    get tumKayitlarAlindi() {
        return this.sayfalama.sayfa >= Math.ceil(this.sayfalama.toplamKayitSayisi / this.sayfalama.sayi)
    }

    sonrakiSayfaEkle() {
        if (this.tumKayitlarAlindi) return;
        if (this.mesgul) return;
        // this.liste=[];
        // this.sayfalama.sonId = this.liste[this.liste.length - 1]._id;
        this.sayfalama.sayfa++;
        // this.sayfalama.ilkId = null;
        this.parametreler = {
            aggregate: this._alAggregate()
        }
        this.iste();
    }

    sayfaDegistir(sayfa: number) {
        // if (this.tumKayitlarAlindi) return;
        // if (this.mesgul) return;
        // this.liste=[];
        // this.sayfalama.sonId = this.liste[this.liste.length - 1]._id;
        this.sayfalama.sayfa = sayfa;
        // this.sayfalama.ilkId = null;
        this.parametreler = {
            aggregate: this._alAggregate()
        }

         this.isteSync();

    }


    sayiDegistir(sayi: number) {
        // if (this.tumKayitlarAlindi) return;
        // if (this.mesgul) return;
        // this.liste=[];
        // this.sayfalama.sonId = this.liste[this.liste.length - 1]._id;
        this.sayfalama.sayi = sayi;
        // this.sayfalama.ilkId = null;
        this.parametreler = {
            aggregate: this._alAggregate()
        }

        this.isteSync();

    }


    listeyiSifirla() {
        // if (!this.tumKayitlarAlindi) return;
        if (this.mesgul) return;
        // this.liste=[];
        // this.sayfalama.sonId = this.liste[this.liste.length - 1]._id;
        this.sayfalama.sayfa = 1;
        this.liste = []

        // this.sayfalama.ilkId = null;
        this.parametreler = {
            aggregate: this._alAggregate()
        }

         this.isteSync();
 

    }
}